"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("../../../../../common/Button/Button"));
var DropDown_1 = __importDefault(require("../../../../../common/DropDown/DropDown"));
var ImagePicker_1 = __importDefault(require("../../../../../common/ImagePicker/ImagePicker"));
var Spinner_1 = __importDefault(require("../../../../../common/Spinner/Spinner"));
var TextInput_1 = __importDefault(require("../../../../../common/TextInput/TextInput"));
var Toast_1 = require("../../../../../common/Toast");
var org_hook_1 = require("../../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../../lib/general");
var getLanguages_1 = require("../../../../../lib/getLanguages");
var icons_1 = __importDefault(require("../../../../../theme/icons"));
var SortingSelector_1 = __importDefault(require("../../../Knowledge/Selectors/SortingSelector"));
var Mutation_1 = require("../../Graphql/Mutation");
var Queries_1 = require("../../Graphql/Queries");
var ServiceCategorySelector_1 = __importDefault(require("../../Selector/ServiceCategorySelector"));
var ServiceCenterForm = function (_a) {
    var list = _a.list, editData = _a.editData, setCenters = _a.setCenters;
    var organization = (0, org_hook_1.useOrg)().organization, _b = (0, react_1.useState)({ en: "", fr: "", rn: "" }), languages = _b[0], setLanguages = _b[1], _c = (0, react_i18next_1.useTranslation)(), i18n = _c.i18n, t = _c.t, iconRef = (0, react_1.createRef)(), history = (0, react_router_dom_1.useHistory)(), getCurrentLang = i18n.language, _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1], _e = (0, react_1.useState)({
        id: editData ? editData.id : null,
        name: editData ? editData.name : JSON.stringify(languages),
        icon: null,
        sorting: editData ? editData.sorting : null,
        organization_id: editData ? editData.organization_id : null,
        phone: editData ? editData.phone : null,
        website: editData ? editData.website : null,
        email: editData ? editData.email : null,
        area1: editData ? editData.area1 : null,
        area2: editData ? editData.area2 : null,
        area3: editData ? editData.area3 : null,
        area4: editData ? editData.area4 : null,
        area5: editData ? editData.area5 : null,
        group: editData ? editData.group : null,
        service_category: editData ? editData.service_categories : null,
        copy_from_service_center_id: null,
    }), fields = _e[0], setFields = _e[1], _f = (0, react_1.useState)({ icon: "" }), fileName = _f[0], setFileName = _f[1], _g = (0, react_1.useState)({ type: "", message: "" }), error = _g[0], setError = _g[1], _h = (0, react_1.useState)({}), addressLabel = _h[0], setAddressLabel = _h[1], _j = (0, react_1.useState)({ prev: null, current: null }), area1 = _j[0], setArea1 = _j[1], _k = (0, react_1.useState)({ prev: null, current: null }), area2 = _k[0], setArea2 = _k[1], _l = (0, react_1.useState)({ prev: null, current: null }), area3 = _l[0], setArea3 = _l[1], _m = (0, react_1.useState)({ prev: null, current: null }), area4 = _m[0], setArea4 = _m[1], _o = (0, react_1.useState)({ prev: null, current: null }), area5 = _o[0], setArea5 = _o[1], _p = (0, react_1.useState)({ prev: null, current: null }), group = _p[0], setGroup = _p[1], _q = (0, react_1.useState)([]), area1List = _q[0], setArea1List = _q[1], _r = (0, react_1.useState)([]), area2List = _r[0], setArea2List = _r[1], _s = (0, react_1.useState)([]), area3List = _s[0], setArea3List = _s[1], _t = (0, react_1.useState)([]), area4List = _t[0], setArea4List = _t[1], _u = (0, react_1.useState)([]), area5List = _u[0], setArea5List = _u[1], _v = (0, react_1.useState)([]), groupList = _v[0], setGroupList = _v[1], _w = (0, react_1.useState)([
        { prev: null, current: null },
    ]), serviceCategory = _w[0], setServiceCategory = _w[1], _x = (0, react_1.useState)([]), serCatList = _x[0], setSerCatList = _x[1], _y = (0, client_1.useMutation)(Mutation_1.DELETE_SERVICE_CENTER, {
        fetchPolicy: "network-only",
        refetchQueries: ["getAllServiceCenterByOrganization"],
    }), callDeleteServiceCenter = _y[0], responseDeleteServiceCenter = _y[1], _z = (0, client_1.useLazyQuery)(Queries_1.GET_ADDRESS_LABEL, {
        fetchPolicy: "network-only",
    }), callAddressLabel = _z[0], responseAddressLabel = _z[1], _0 = (0, client_1.useLazyQuery)(Queries_1.GET_ADDRESS_LIST, {
        fetchPolicy: "network-only",
    }), callAdressList = _0[0], responseAddressLIst = _0[1];
    var _1 = (0, client_1.useLazyQuery)(Queries_1.GET_SERVICE_CATEGORY, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), callCatData = _1[0], data = _1[1].data;
    var callServiceCenterList = (0, client_1.useLazyQuery)(Queries_1.GET_SERVICE_CENTER_BY_ORGANIZATION, {
        variables: { organization_id: organization.id },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function (data) {
            setCenters === null || setCenters === void 0 ? void 0 : setCenters(data.getAllServiceCenterByOrganization);
        },
        onError: function () {
            // setLoading(false);
        },
    })[0];
    var _2 = (0, client_1.useMutation)(Mutation_1.UPSERT_SERVICE_CENTER, {
        fetchPolicy: "no-cache",
        // refetchQueries: ["callServiceCenterList"],
        onCompleted: function (res) {
            // setLoading(false);
            // setSuccess(res.data.bulkUpsertServiceCenter);
        },
        onError: function () {
            // setLoading(false);
        },
    }), callUpsertCenter = _2[0], responseUpsertCenter = _2[1];
    (0, react_1.useEffect)(function () {
        getLanguageList();
        editData && onEditClick(editData);
    }, []);
    (0, react_1.useEffect)(function () {
        getServiceCategory();
    }, [organization.id, serviceCategory]);
    var getServiceCategory = function () { return __awaiter(void 0, void 0, void 0, function () {
        var catListResponse, serviceCatList, item;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, callCatData({
                        variables: {
                            organization_id: organization.id,
                        },
                    })];
                case 1:
                    catListResponse = _b.sent();
                    serviceCatList = (_a = catListResponse.data) === null || _a === void 0 ? void 0 : _a.getAllServiceCategoriesByOrganization;
                    item = [];
                    if (serviceCatList.length > 0) {
                        serviceCatList.map(function (l) {
                            item.push({ id: l.id, name: l.name });
                        });
                    }
                    setSerCatList(item);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getAddressList();
    }, [area1, area2, area3, area4, area5, group]);
    var getAddressList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var listResponse, list;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, callAdressList({
                        variables: {
                            area1: area1.current,
                            area2: area2.current,
                            area3: area3.current,
                            area4: area4.current,
                            area5: area5.current,
                            group: group.current,
                        },
                    })];
                case 1:
                    listResponse = _a.sent();
                    list = listResponse.data.getAddressBySelected;
                    area1.current === null &&
                        setArea1List(__spreadArray([], list.map(function (val) {
                            return { label: val.area1, value: val.area1 };
                        }), true));
                    area2.current === null &&
                        setArea2List(__spreadArray([], list.map(function (val) {
                            return { label: val.area2, value: val.area2 };
                        }), true));
                    area3.current === null &&
                        setArea3List(__spreadArray([], list.map(function (val) {
                            return { label: val.area3, value: val.area3 };
                        }), true));
                    area4.current === null &&
                        setArea4List(__spreadArray([], list.map(function (val) {
                            return { label: val.area4, value: val.area4 };
                        }), true));
                    area5.current === null &&
                        setArea5List(__spreadArray([], list.map(function (val) {
                            return { label: val.area5, value: val.area5 };
                        }), true));
                    group.current === null &&
                        setGroupList(__spreadArray([], list.map(function (val) {
                            return { label: val.group, value: val.group };
                        }), true));
                    return [2 /*return*/];
            }
        });
    }); };
    var getLanguageList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list, addressList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, getLanguages_1.getLanguages)()];
                case 1:
                    list = _a.sent();
                    return [4 /*yield*/, callAddressLabel()];
                case 2:
                    addressList = _a.sent();
                    setAddressLabel(addressList.data.getAddressLabel);
                    setLanguages(list);
                    setFields({
                        id: editData ? editData.id : null,
                        name: editData ? editData.name : JSON.stringify(languages),
                        icon: null,
                        sorting: editData ? editData.icon : null,
                        organization_id: editData ? editData.organization_id : null,
                        phone: editData ? editData.phone : null,
                        website: editData ? editData.website : null,
                        email: editData ? editData.email : null,
                        area1: editData ? editData.area1 : null,
                        area2: editData ? editData.area2 : null,
                        area3: editData ? editData.area3 : null,
                        area4: editData ? editData.area4 : null,
                        area5: editData ? editData.area5 : null,
                        group: editData ? editData.group : null,
                        copy_from_service_center_id: null,
                        service_category: editData
                            ? editData.service_categories.map(function (service) {
                                return {
                                    value: service.id,
                                    label: (0, general_1.isJsonWithAvailableLang)(service.name, getCurrentLang, t),
                                };
                            })
                            : null,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setFields({
            id: null,
            name: JSON.stringify(languages),
            icon: null,
            sorting: null,
            organization_id: organization.id,
            phone: null,
            website: null,
            email: null,
            area1: null,
            area2: null,
            area3: null,
            area4: null,
            area5: null,
            group: null,
            service_category: null,
        });
        setFileName({ icon: "" });
    };
    var handleChange = function (value, name, type) {
        setError({ type: "", message: "" });
        fields.organization_id = organization.id;
        if (type === "json") {
            var dataObj_1 = JSON.parse(fields[name]);
            dataObj_1[getCurrentLang] = value;
            setFields(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = JSON.stringify(dataObj_1), _a)));
            });
        }
        else if (type === "obj") {
            var currentInput_1 = name;
            var video_file_1 = value.video_file, thumbnail_file_1 = value.thumbnail_file;
            if (video_file_1) {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = video_file_1.name, _a)));
                });
                setFields(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = __assign(__assign({}, prevState[currentInput_1]), (_b = {}, _b[getCurrentLang] = video_file_1, _b)), _a)));
                });
            }
            if (thumbnail_file_1) {
                setFields(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a["thumbnail"] = __assign(__assign({}, prevState["thumbnail"]), (_b = {}, _b[getCurrentLang] = thumbnail_file_1, _b)), _a)));
                });
            }
        }
        else {
            if (type === "icon") {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value.name, _a)));
                });
            }
            setFields(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
            });
        }
    };
    var createUI = function () { return (react_1.default.createElement("div", { className: "inner-content" },
        react_1.default.createElement(TextInput_1.default, { error: error && error.type === "name" && error.message, label: t("name"), onChange: function (e) { return handleChange(e.target.value, "name", "json"); }, value: (0, general_1.isJsonWithAvailableLang)(fields === null || fields === void 0 ? void 0 : fields.name, getCurrentLang, t) || "" }),
        react_1.default.createElement(ImagePicker_1.default, { fileName: fileName, id: "icon", imagechange: function (file) { return handleChange(file, "icon", "icon"); }, imgref: iconRef, label: t("icon"), mediatype: "image" }),
        react_1.default.createElement(TextInput_1.default, { error: error.type === "phone" && error.message, label: t("phone"), onChange: function (e) { return handleChange(e.target.value, "phone", ""); }, value: (fields === null || fields === void 0 ? void 0 : fields.phone) || "" }),
        react_1.default.createElement(TextInput_1.default, { error: error.type === "email" && error.message, label: t("email"), onChange: function (e) { return handleChange(e.target.value, "email", ""); }, value: (fields === null || fields === void 0 ? void 0 : fields.email) || "" }),
        react_1.default.createElement(TextInput_1.default, { error: error.type === "website" && error.message, label: t("website"), onChange: function (e) { return handleChange(e.target.value, "website", ""); }, value: (fields === null || fields === void 0 ? void 0 : fields.website) || "" }),
        react_1.default.createElement(ServiceCategorySelector_1.default, { options: serCatList, label: t("service_category"), onChange: function (e) {
                setFields(function (prev) { return (__assign(__assign({}, prev), { service_category: e })); });
            }, value: fields.service_category }),
        react_1.default.createElement(DropDown_1.default, { error: error.type === "area1" && error.message, isMulti: false, label: addressLabel.area1, options: area1List, onChange: function (e) {
                setArea1({ prev: area1.current, current: e.value });
                setArea2({ prev: area2.current, current: null });
                setArea3({ prev: area3.current, current: null });
                setArea4({ prev: area4.current, current: null });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                handleChange(e.value, "area1", "");
            }, value: area1.current }),
        react_1.default.createElement(DropDown_1.default, { options: area2List, error: error.type === "area2" && error.message, isMulti: false, label: addressLabel.area2, onChange: function (e) {
                setArea2({ prev: area2.current, current: e.value });
                setArea3({ prev: area3.current, current: null });
                setArea4({ prev: area4.current, current: null });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                handleChange(e.value, "area2", "");
            }, value: area2.current }),
        react_1.default.createElement(DropDown_1.default, { options: area3List, error: error.type === "area3" && error.message, isMulti: false, label: addressLabel.area3, onChange: function (e) {
                setArea3({ prev: area3.current, current: e.value });
                setArea4({ prev: area4.current, current: null });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                handleChange(e.value, "area3", "");
            }, value: area3.current }),
        react_1.default.createElement(DropDown_1.default, { options: area4List, error: error.type === "area4" && error.message, isMulti: false, label: addressLabel.area4, onChange: function (e) {
                setArea4({ prev: area4.current, current: e.value });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                handleChange(e.value, "area4", "");
            }, value: area4.current }),
        react_1.default.createElement(DropDown_1.default, { options: area5List, error: error.type === "area5" && error.message, isMulti: false, label: addressLabel.area5, onChange: function (e) {
                setArea5({ prev: area5.current, current: e.value });
                setGroup({ prev: group.current, current: null });
                handleChange(e.value, "area5", "");
            }, value: area5.current }),
        react_1.default.createElement(DropDown_1.default, { options: groupList, error: error.type === "group" && error.message, isMulti: false, label: addressLabel.group, onChange: function (e) {
                setGroup({ prev: group.current, current: e.value });
                handleChange(e.value, "group", "");
            }, value: group.current }),
        react_1.default.createElement(SortingSelector_1.default, { list: list || [], onChange: function (e) {
                handleChange(e.sorting_id, "sorting", "");
            }, value: fields.sorting }),
        react_1.default.createElement(Button_1.default, { className: "modal-button", icon: react_1.default.createElement(icons_1.default, { name: "tick", className: "icon", height: 30, width: 30 }), onClick: function () { return onSaveClick(); }, style: { marginTop: "3vh" } }))); };
    var onSaveClick = function () {
        var tmp = __assign({}, fields), errortmp = { type: "", message: "" };
        if (fields.name[getCurrentLang] === "") {
            errortmp = {
                type: "name",
                message: "required",
            };
        }
        else {
            var id = fields.id, name_1 = fields.name, icon = fields.icon, sorting = fields.sorting ? parseInt(fields.sorting) : null, phone = fields.phone, website = fields.phone, email = fields.phone, area1_1 = fields.area1, area2_1 = fields.area2, area3_1 = fields.area3, area4_1 = fields.area4, area5_1 = fields.area5, group_1 = fields.group, service_categories = fields.service_category.map(function (service) {
                return { id: service.value };
            });
            tmp = {
                id: id,
                name: name_1,
                icon: icon,
                sorting: sorting,
                organization_id: organization.id,
                phone: phone,
                website: website,
                email: email,
                area1: area1_1,
                area2: area2_1,
                area3: area3_1,
                area4: area4_1,
                area5: area5_1,
                group: group_1,
                service_categories: service_categories,
            };
        }
        // if (tmp.length === fields.length && tmp.length > 0) {
        onSave([tmp]);
        setFields("");
        // } else {
        setError(errortmp);
        // }
    }, onSave = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var variables;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    variables = { input: data };
                    return [4 /*yield*/, callUpsertCenter({
                            variables: variables,
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, callServiceCenterList({
                            variables: {
                                organization_id: organization.id,
                            },
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, onEditClick = function (item) {
        var parsedName = JSON.parse(item.name);
        setArea1({ prev: item.area1, current: item.area1 });
        setArea2({ prev: item.area2, current: item.area2 });
        setArea3({ prev: item.area3, current: item.area3 });
        setArea4({ prev: item.area4, current: item.area4 });
        setArea5({ prev: item.area5, current: item.area5 });
        setGroup({ prev: item.group, current: item.group });
        setFields({
            id: item.id,
            name: parsedName,
            icon: null,
            sorting: item.sorting,
            organization_id: item.organization_id,
            phone: item.phone,
            website: item.website,
            email: item.email,
            area1: item.area1,
            area2: item.area2,
            area3: item.area3,
            area4: item.area4,
            area5: item.area5,
            group: item.group,
            service_category: item.service_categories.map(function (service) {
                return {
                    value: service.id,
                    label: (0, general_1.isJsonWithAvailableLang)(service.name, getCurrentLang, t),
                };
            }),
        });
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        (loading ||
            (responseDeleteServiceCenter === null || responseDeleteServiceCenter === void 0 ? void 0 : responseDeleteServiceCenter.loading) ||
            (responseUpsertCenter === null || responseUpsertCenter === void 0 ? void 0 : responseUpsertCenter.loading)) && react_1.default.createElement(Spinner_1.default, null),
        (responseUpsertCenter === null || responseUpsertCenter === void 0 ? void 0 : responseUpsertCenter.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t("added_successfully"), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        (responseDeleteServiceCenter === null || responseDeleteServiceCenter === void 0 ? void 0 : responseDeleteServiceCenter.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t("deleted_successfully"), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        createUI()));
};
exports.default = ServiceCenterForm;
